import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {AdController, AdService} from 'legacy-advertising';
import {CloseXIcon} from '../../../../../shared/Svgs';
import styles from './MobileOverlayAd.styl';
import classNames from 'classnames/bind';
import withScrollPos from '../WithScrollPos';

const cx = classNames.bind(styles);
const THRESHOLD = 400;

export class MobileOverlayAd extends Component {
  static propTypes = {
    adService: PropTypes.shape({type: PropTypes.instanceOf(AdService)})
      .isRequired,
    positionId: PropTypes.string.isRequired,
  };

  state = {
    slotLoaded: false,
    isClosed: false,
  };

  handleClick = () => {
    this.setState({
      isClosed: true,
    });
  };

  handleAdEvent = eventName => {
    // don't show the ad until it has loaded
    if (eventName === 'slotOnLoad') {
      this.setState({
        slotLoaded: true,
      });
    }
  };

  render() {
    const {isClosed, slotLoaded} = this.state;
    const {thresholdTriggered} = this.props;

    /*
     * Display ad if:
     * - we're client side (window !== undefined)
     * - The window is less than or equal to 900px wide (max-width: 900px)
     */
    const displayAd =
      typeof window !== 'undefined' &&
      window.matchMedia('(max-width: 900px)').matches;

    if (!displayAd) {
      return null;
    }

    const {adService, positionId} = this.props;

    const classes = cx({
      MobileOverlay: true,
      isVisible: slotLoaded && thresholdTriggered && !isClosed,
    });

    return (
      <div className={classes}>
        <button
          className={styles.MobileOverlayCloseButton}
          onClick={this.handleClick}
        >
          <CloseXIcon size={14} />
        </button>
        <AdController
          onAdEvent={this.handleAdEvent}
          adService={adService}
          adSize={[[1, 1], [728, 90], [970, 90], [320, 50], 'fluid']}
          pageName="fh-profile"
          positionId={positionId}
          responsiveSizeMap="mapping320x250DisplayOverlay1"
        />
      </div>
    );
  }
}

const mapStateToProps = state => ({
  adService: state.adStore.adService,
});

export default connect(mapStateToProps)(
  withScrollPos(MobileOverlayAd, {threshold: THRESHOLD})
);



// WEBPACK FOOTER //
// ./src/reactModules/pages/Profile/components/Shared/MobileOverlayAd/index.js